import { Component } from 'preact'
import ShowMoreButton from './ShowMoreButton'
import QuickLinksList from './QuickLinksList'
import QuickLink from './QuickLink'

export default class QuickLinksContainer extends Component {
  constructor (props) {
    super()

    this.state = {
      showAll: props.showAll
    }
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  showMoreHandler () {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  render (props, state) {
    const { data, settings, itemsPerContainer, title } = props
    const { showAll } = state

    if (!data.length) {
      return null
    }

    return (
      <section class='full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper homepage-widget-wrapper custom-quicklink'>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <QuickLinksList>
              { data.map((item, idx) => <QuickLink
                item={item}
                idx={idx}
                enableBorder={settings.enableBorder}
                borderRadius={settings.borderRadius}
                isVisibleDesktop={showAll || idx < itemsPerContainer}
              />)}
            </QuickLinksList>
          </div>
        </div>
        {(data.length > itemsPerContainer) &&
          <ShowMoreButton
            quickLinksLength={data.length}
            itemsPerContainer={itemsPerContainer}
            showMore={this.showMoreHandler}
            showAll={showAll} />}
      </section>
    )
  }
}
